export default {
  LANDING: 'landing',
  JOIN_THE_HEAD_OFFICE_TEAM: 'joinTheHeadOfficeTeam',
  BECOME_A_DISTRICT_MANAGER: 'becomeADistrictManager',
  CAREERS_FAQS: 'careersFaqs',
};
